import { AxiosResponse, axios } from '~/modules'
import { IPatient, IGetPatientParams, IGetPatientsParams, IPatientsPageable } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchPatient = async (params: IGetPatientParams): Promise<IPatient> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.medicalRecord}`)
  const { data }: AxiosResponse<IPatient> = response
  return data
}

export const fetchPatients = async (params: IGetPatientsParams): Promise<IPatientsPageable> => {
  const { queryParams } = params
  const response = await axios.get(`${hstoryAPI}/patients`, { params: queryParams })
  const { data }: AxiosResponse<IPatientsPageable> = response
  return data
}
